export default ({ app }) => {
  // ResizeObserver loop limit exceeded
  // https://github.com/Fundebug/reproduce-ResizeObserver-loop-limit-exceeded
  window.onerror = (message, source, lineno, colno, error) => {}
}
